import { useAccountPreferences } from '~publish/contexts/AccountContext'
import type { ScheduleOption } from '~publish/gql/graphql'

export const useDefaultScheduleOption = (): ScheduleOption => {
  const defaultScheduleOption = useAccountPreferences()?.defaultScheduleOption

  return defaultScheduleOption ?? 'Queue'
}
